import React from 'react';
import ReportHeatmapTable from "../../../../../components/reports/report-heatmap-table/report-heatmap-table.jsx";

const HeatMap = ({data}) => {
    return (
        <div id="createAttendanceByWeekDayTable" className={"break-inside-avoid"}>

            <ReportHeatmapTable
                data={data?.attendancesByWeekday ?? []}
                title={'Atendimentos por dia da semana com intervalo de 1 hora'}
                sheetName={'Atendimentos por dia da semana'}
                columns={[
                    { key: "segunda", label: "Segunda" },
                    { key: "terca", label: "Terça" },
                    { key: "quarta", label: "Quarta" },
                    { key: "quinta", label: "Quinta" },
                    { key: "sexta", label: "Sexta" },
                    { key: "sabado", label: "Sábado" },
                    { key: "domingo", label: "Domingo" },
                ]}
            />

        </div>
    );
};

export default HeatMap;